import { apiClient } from '../../../gateways/api'
import type { AccountOption } from '../types/AccountOption'

import { MIN_QUERY_SIZE, initialState } from './fetchContactpersoonAccounts'

export { fetchContactpersoonFilterAccounts }

async function fetchContactpersoonFilterAccounts({
  text,
}: {
  text: string
}): Promise<AccountOption[]> {
  if (text.trim().length < MIN_QUERY_SIZE) return initialState.data

  const { data } = await apiClient({
    url: '/rest/project/hoofdleiding/contactpersoon-accounts',
    method: 'GET',
    params: { text: text.trim() },
  })

  return data
}
